<script>
import forminput from "../FormComponet/forminput.vue";
import formtextarea from "../FormComponet/formtextarea.vue";
//import formcheckbox from "../FormComponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrSorgular from "@/models/StrSorgular";
export default {
  mixins: [Api, Sabit, StrSorgular],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
   // formcheckbox,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        if (this.AddEdit == "Add") {
          this.Post("StrSorgular", this.FormData);
          this.$bvModal.hide("StrSorgular"); 
        } else {
          this.Update("StrSorgular", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrSorgular");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrSorgular"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrSorgular.AddEdit.FormTitleEdit')
          : $t('StrSorgular.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit"> 
        <forminput
          :FormDataType="FormDataType.Sorguadi"
          :Value="FormData.Sorguadi"
          :v="$v.FormData.Sorguadi"
          @input="FormData.Sorguadi = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Sorgu"
          :Value="FormData.Sorgu"
          :v="$v.FormData.Sorgu"
          @input="FormData.Sorgu = $event"
        />

        <forminput
          :FormDataType="FormDataType.Parametreler"
          :Value="FormData.Parametreler"
          :v="$v.FormData.Parametreler"
          @input="FormData.Parametreler = $event"
        />
       <!--
       <formcheckbox
          :FormDataType="FormDataType.Aktif"
          :Value="FormData.Aktif"
          :v="$v.FormData.Aktif"
          @input="FormData.Aktif = $event"
        /> -->
        <button class="btn btn-primary" type="submit">
          {{ $t("StrSorgular.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
